import { useAuth } from "@provider/context-auth";
import * as React from "react";
import { Platform } from "react-native";

import { parseMandateStatus, showMandateResult } from "./mandate-result";

const PARAM = "machtiging";

// stripParam haalt ?machtiging= uit de adresbalk (anders komt de melding bij
// elke reload terug).
function stripParam() {
  const url = new URL(window.location.href);
  if (url.searchParams.has(PARAM)) {
    url.searchParams.delete(PARAM);
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  }
}

// De status lezen én de parameter weghalen we bij het laden van de bundle:
// de navigatie leest de URL bij het opstarten en schrijft hem daarna terug,
// dus een parameter die er dan nog staat, komt terug in de adresbalk.
const initialStatus = (() => {
  try {
    if (Platform.OS !== "web" || typeof window === "undefined") {
      return null;
    }
    const status = parseMandateStatus(new URL(window.location.href).searchParams.get(PARAM));
    stripParam();
    return status;
  } catch {
    return null;
  }
})();
let handled = false;

// MandateReturn (web): na de machtiging bij Mollie komt de klant in dit
// tabblad terug op /app/account?machtiging=ok|fout. Toon de melding, haal het
// profiel opnieuw op en haal de parameter uit de adresbalk (anders komt de
// melding bij elke reload terug). De uitkomst zelf staat in het profiel
// (pay_with_sepa); de parameter bepaalt alleen de melding.
export default function MandateReturn(): null {
  const { refetch } = useAuth();
  React.useEffect(() => {
    if (handled || Platform.OS !== "web" || typeof window === "undefined") {
      return;
    }
    handled = true;
    try {
      // Nog een keer na het opstarten van de navigatie, voor het geval die de
      // URL toch met de oude parameter terugschreef.
      stripParam();
      setTimeout(stripParam, 500);
      if (initialStatus) {
        showMandateResult(initialStatus);
        refetch();
      }
    } catch (e) {
      console.log("machtiging-terugkeer", e);
    }
    // alleen bij het laden van de pagina
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
